import {Component} from 'react';
import React from 'react';
import App from "./App";

import {Elements, StripeProvider} from "react-stripe-elements";

const publicKey_live = "pk_live_A6LiJRkZWa5MNguc1bdcnMzN";
const publicKey = "pk_test_B4KfjhTC3DcB2lQM0pAHXUEG";

class AppWrapper extends Component {
    constructor(props) {
        /*
        
        */
        super(props);
    }
    
    render() {
        return (
            <StripeProvider apiKey={publicKey}>
            <Elements>
                <App publicKey={publicKey}/>
            </Elements>
            </StripeProvider>
        );
    }
}

export default AppWrapper;